import { cn } from '@/utils/style'

interface DividerProps {
  className?: string
}

export function Divider({ className }: DividerProps) {
  return <div className={cn('w-full h-0 border-b border-gray100 mb-8', className)}></div>
}
